export default "__VITE_ASSET__BSMXYWoT__"